import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

const OfflineBar = ({ open, message, onRetry, onClose, isOnline }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={isOnline ? 3000 : null}
      onClose={onClose}
      sx={{ bottom: 16, zIndex: (theme) => theme.zIndex.snackbar + 1 }} // Ensures it appears on top
    >
      <Alert
        onClose={onClose}
        severity={isOnline ? 'success' : 'error'}
        variant="filled"
        action={
          !isOnline && (
            <>
              {onRetry && (
                <Button color="inherit" size="small" onClick={onRetry}>
                  Retry
                </Button>
              )}
              {onClose && (
                <Button color="inherit" size="small" onClick={onClose}>
                  Close
                </Button>
              )}
            </>
          )
        }
        sx={{
          width: '100%',
          boxShadow: '0px -2px 10px rgba(0,0,0,0.2)',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default OfflineBar;
